import {Outlet} from "react-router-dom";
import "./ContentPage.scss";
import SiteFooter from "./SiteFooter";

export default function ContentPage() {
  return <div className={"content-page"}>
    <Outlet />
    <SiteFooter/>
  </div>
}
